import { useEffect, useState } from 'react';

export const useFetchDataByPage = (
  defaultLimit: number,
  fetchFunction: (page: number, limit: number) => Promise<any>,
  setData: (data: any) => void
) => {
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const page = Number.isNaN(urlParams.get('page'))
      ? 1
      : +urlParams.get('page');
    setCurrentPage(page);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchFunction(1, defaultLimit * currentPage);
      setData(response);
    };
    if (currentPage > 1) {
      fetchData();
    }
  }, [currentPage]);
};
